import { HttpService } from '../http.service'
import { usePayrollStore } from '@/store/payroll-data'
import { useRoute } from 'vue-router'

const http = new HttpService()

export async function getData<T>(query: TableDataQuery): Promise<T> {
  query.where = query.where ?? []
  replaceWhereTags(query)
  const executedQuery = {
    type: 'select',
    ...query
  }
  const response: any = await http.post('get-table/query', executedQuery)

  return [response?.data?.data, executedQuery] as T
}

export async function getSelectData<T>(
  query: TableDataQuery,
  params?: Map<string, string>,
  selectId?: string,
  operator: string = '='
): Promise<T> {
  const localQuery = { ...query }
  localQuery.where = localQuery.where ?? []
  replaceWhereTags(localQuery, selectId)
  replaceJoinTags(localQuery, selectId)

  localQuery.options = localQuery.options ?? {}

  if (params) {
    params.forEach((value, key) => {
      localQuery.where?.push(`${key} ${operator} '${value}'`)
    })
  }

  const response: any = await http.post('get-table/query', {
    type: 'select',
    ...localQuery
  })

  return response?.data?.data?.results as T
}

function replaceWhereTags(query: TableDataQuery, selectId?: string) {
  if (query.where) {
    query.where = query.where.map((where: string) => {
      return replacePayrollTags(where, true, selectId)
    })
  }
}

function replaceJoinTags(query: TableDataQuery, selectId?: string) {
  if (query.join) {
    query.join = query.join.map((join: string) => {
      return replacePayrollTags(join, true, selectId)
    })
  }
}

export function replacePayrollTags(
  text: string = '',
  addQuotes: boolean = false,
  selectId?: string
): string {
  if (!text || typeof text !== 'string') return text
  const store = usePayrollStore()
  text = text
    .replace(/:countryId/g, `'${store.payroll?.country?.id ?? ''}'`)
    .replace(/:companyId/g, `'${store.payroll?.company?.id ?? ''}'`)
    .replace(/:payrollId/g, `'${store.payroll?.id ?? ''}'`)
    .replace(/:currencyId/g, `'${store.payroll?.currency_id ?? ''}'`)
    .replace(/:selectId/g, `'${selectId ?? ''}'`)

  if (text.includes(':currentId') && useRoute()?.params?.id) {
    text = text.replace(
      /:currentId/g,
      `'${useRoute()?.params?.id?.toString()}'`
    )
  } else {
    text = text.replace(/:currentId/g, `'${store.payroll?.id ?? ''}'`)
  }

  if (!addQuotes) text = text?.replaceAll("'", '')
  return text
}

export interface TableDataQuery {
  tables: string[]
  groupedBy?: string
  fields: string[]
  join?: string[]
  where?: string[]
  modifier?: string[]
  options?: {
    outputFormat?: string
    allowDeleted?: boolean
    pagination?: {
      offset?: number
      limit?: number
    }
  }
}

export interface TableDataResponse<T> {
  results: T[]
  totalItems: number
}

export interface SelectOption {
  id: string | number | null
  name: string
  [key: string]: any
}
